<mat-dialog-content>
    <div fxLayout='column'>
        <p>
            You need to activate SU Podium V2.6 before you can download any components from Podium Browser V3.  Podium Browser V3 is now part of SU Podium V2.6. If you are using a trial version of SU Podium V2.6 and want to see some Podium Browser components, please click the above help button.
        </p>
        <mat-dialog-actions fxLayout='row'>
            <button fxFlex="0 0 auto" mat-raised-button color="warn" mat-dialog-close>Cancel</button>
        </mat-dialog-actions>
    </div>
</mat-dialog-content>



// WEBPACK FOOTER //
// ./src/app/login-reminder-modal/login-reminder-modal.component.html